import { connect } from 'react-redux'

import LocaleWrapper from './LocaleWrapper'

const mapStateToProps = state => ({
  dataLang: state.intlState.dataLang
})

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocaleWrapper)
